import { firmNameRequestSchema, meSchema, type FirmNameRequest, type Me } from "@contract/firm/me";
import { apiRequest } from "./client";

/** GET /v1/me: the first call provisions the account (firm-model spec §5.3). */
export function fetchMe(): Promise<Me> {
  return apiRequest("/v1/me", {}, (json) => meSchema.parse(json));
}

/** PUT /v1/firm/name (`manage_members`): rename the firm (Home's Your Firm card). */
export async function renameFirm(name: string): Promise<string> {
  const body: FirmNameRequest = { name };
  const res = await apiRequest("/v1/firm/name", { method: "PUT", body }, (json) => firmNameRequestSchema.parse(json));
  return res.name;
}
